<template>
  <header id="applicationHeader" :class="headerClass" role="banner">
    <div class="container p-0 position-relative">
      <div class="row g-0 bloc-entete px-md-5 px-lg-0">
        <MenuToggler @toggleMenu="toggleMenu" />
        <!-- menu pour tablette -->
        <div
          :id="navId"
          :class="toggleMenuClass"
          class="applicationMenuTablet-container navbar-collapse position-absolute p-1 border-gray-400"
        >
          <ApplicationMenu id="applicationMenuTablet" :config="menuConfig" />
        </div>
        <!-- Entité servicielle -->
        <div class="col-12 d-flex justify-content-between flex-fill">
          <EntiteServicielle
            class="justify-content-start d-flex flex-fill"
            :blocMarqueConfig="blocMarqueConfig"
            :logoConfig="logoConfig"
          >
            <template v-slot:customBlocLogotype>
              <slot #customBlocLogotype></slot>
            </template>
          </EntiteServicielle>
          <!-- Bloc privé -->
          <BlocPriveConnected
            v-if="$store.getters['user/isAuthenticated']"
            :headerClass="headerClass"
            :disconnectConfig="disconnectConfig"
            :profilConfig="profilConfig"
            :searchConfig="searchConfig"
            :customConnectedButtons="customConnectedButtons"
            v-on="$listeners"
          />
          <BlocPriveDisconnected v-else :connectConfig="connectConfig" @connect="$emit('connect')" />
        </div>
      </div>
    </div>
  </header>
</template>

      
<script>
import MenuToggler from "./MobileTablet/MenuToggler";
import EntiteServicielle from "./Common/EntiteServicielle";
import BlocPriveConnected from "./PcTablet/BlocPriveConnected";
import BlocPriveDisconnected from "./PcTablet/BlocPriveDisconnected";

import ApplicationMenu from "./Tablet/ApplicationMenu";
import ApplicationMenuConfig from "@clir/ApplicationMenu/ApplicationMenuConfig";

import generateUid from "@/clir/utils/generateUid/";
const selectorId = "nav" + generateUid();

export default {
  name: "ApplicationHeaderPcTablet",
  data() {
    return { navId: selectorId, showMenu: false };
  },
  computed: {
    toggleMenuClass() {
      return this.showMenu ? "" : "d-none";
    }
  },
  watch: {
    $route() {
      this.showMenu = false;
    }
  },
  props: {
    headerClass: { type: String, default: "" },
    blocMarqueConfig: { type: Object, default: () => {} },
    logoConfig: { type: Object, default: () => {} },
    customConnectedButtons: { type: Array, default: () => [] },
    disconnectConfig: { type: Object, default: () => {} },
    profilConfig: { type: Object, default: () => {} },
    searchConfig: { type: Object, default: () => {} },
    connectConfig: { type: Object, default: () => {} },
    menuConfig: { type: Object, default: () => ApplicationMenuConfig }
  },
  mounted() {
    document.body.addEventListener("mouseup", this.clickOutsideMenu);
  },
  methods: {
    toggleMenu() {
      this.showMenu=!this.showMenu;
    },
    clickOutsideMenu(event) {
      const target = event.target;
      const menu = document.querySelector(`#${this.navId}`);
      const toggler = document.querySelector(`#applicationHeader button.menutoggler`);
      if (menu && !menu.contains(target) && !toggler.contains(target))
        this.$nextTick(() => (this.showMenu = false));
    }
  },
  components: {
    MenuToggler,
    EntiteServicielle,
    BlocPriveConnected,
    BlocPriveDisconnected,
    ApplicationMenu
  }
};
</script>
<style scoped>
.applicationMenuTablet-container {
  left: 0.25rem !important;
  top: 2.25rem !important;
  z-index: 1000;
}
</style>